import { BrandVersion } from '../services';

/** Portal footer (`Footer.tsx`) always uses Transcepta naming for both brand modes. */
export const getBrandInfo = (brand: BrandVersion) => {
    void brand;
    return {
        brandName: 'Transcepta',
        formalBrandName: 'Transcepta LLC',
    };
};
